var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 130,
    height: 134,
    viewBox: "0 0 130 134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_480",
    "data-name": "Raggruppa 480",
    transform: "translate(-277.5 -302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_45",
    "data-name": "Rettangolo 45",
    d: "M8,0H130a0,0,0,0,1,0,0V134a0,0,0,0,1,0,0H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z",
    transform: "translate(277.5 302)",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_479",
    "data-name": "Raggruppa 479",
    transform: "translate(297.624 342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_104",
    "data-name": "Tracciato 104",
    d: "M402.577,871.348h0c-21.47,12.038-32.354,5.076-32.354,34.376H460.6c0-28.14-10.88-22.338-32.348-34.376A19.048,19.048,0,0,1,415.631,877a19.8,19.8,0,0,1-13.052-5.654Z",
    transform: "translate(-370.223 -811.96)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_105",
    "data-name": "Tracciato 105",
    d: "M428.955,859.439h0c-.726-.434-1.306-.29-1.6.442,0,0,2.03-11.026.436-15.814-3.482-12.042-32.058-15.376-32.058-7.836-12.184,3.338-10.012,14.944-8.266,23.8a1.142,1.142,0,0,0-1.89,0c-1.3,1.3.146,4.782.582,6.382a11.16,11.16,0,0,0,1.02,2.756v.434c0,1.158.58,2.034,1.16,2.034h0c2.9,11.024,11.46,20.014,19.144,20.014,7.112,0,15.814-9,18.57-20.014.582,0,1.16-.876,1.16-2.034v-.292a23.26,23.26,0,0,0,1.16-2.9c.436-1.448,2.036-5.946.58-6.968Z",
    transform: "translate(-362.549 -832.215)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverPlaceholder);
export default __webpack_public_path__ + "static/media/DriverPlaceholder.d01081bfac178cd31e306def84b89203.svg";
export { ForwardRef as ReactComponent };